import type { ChartTooltipContent } from './chart-tooltip.types';

const SERIES_A_ROWS: ChartTooltipContent['rows'] = [
  {
    color: { kind: 'series', step: 1 },
    name: 'D3 1호 펀드',
    value: '8.3%',
    note: '신규투자: 500 백만원 (12,500주)',
  },
  {
    color: { kind: 'series', step: 4 },
    name: '기존 주주',
    value: '50.0%',
    note: '신규투자: 0 백만원 (0주)',
  },
  {
    color: { kind: 'series', step: 3 },
    name: '신규 라운드 투자',
    value: '25.0%',
    note: '신규투자: 3,000 백만원 (75,000주)',
  },
  { color: { kind: 'series', step: 5 }, name: '스톡옵션', value: '5.0%' },
  {
    color: { kind: 'series', step: 2 },
    name: 'D3 2호 펀드',
    value: '4.2%',
    note: '신규투자: 300 백만원 (7,500주)',
  },
  { color: { kind: 'series', step: 6 }, name: '리픽싱', value: '2.0%' },
];

/** Figma 예시(ChartTooltip 2033:72): 줄 2개 · 줄 6개(넘침) */
export const chartTooltipFixture = {
  twoRows: {
    title: 'Series A',
    summary: '기업가치: 12,000,000,000원',
    subtitle: '지분 구성:',
    rows: SERIES_A_ROWS.slice(0, 2),
  },
  sixRows: {
    title: 'Series A',
    summary: '기업가치: 12,000,000,000원',
    subtitle: '지분 구성:',
    rows: SERIES_A_ROWS,
  },
} satisfies Record<string, ChartTooltipContent>;
